<app-navbar></app-navbar>
<div class="register-page-content">
  <div
    *ngIf="selectedType != null"
    class="flex-row flex-sm-row my-4 text-center user-types-list container"
  >
    <label class="select">
      <select
        class="text-center select form-control"
        [(ngModel)]="selectedType"
        (change)="onChange($event.target.value)"
      >
        <option class="bg-white text-black" disabled [value]="null">
          الرجاء إختيار نوع العميل
        </option>
        <option class="bg-white text-black" [value]="userTypes.TRANSPORTER">
          ناقل
        </option>
        <option class="bg-white text-black" [value]="userTypes.SELLER">
          بائع
        </option>
        <option class="bg-white text-black" [value]="userTypes.BUYER">
          مشتري
        </option>
        <option class="bg-white text-black" [value]="userTypes.BUYER_SELLER">
          مشتري وبائع
        </option>
      </select>
    </label>
  </div>

  <div class="bg-gradient-default shape shape-style-1">
    <span></span>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
  </div>

  <div class="register-page-type-container">
    <div *ngIf="selectedType == null" class="my-3">
      <div class="justify-content-center row">
        <div class="col-lg-12">
          <div class="bg-white shadow card register-card">
            <div class="px-lg-5 py-lg-5 card-body">
              <div class="mb-4 text-create-account text-muted text-center">
                <small>إنشاء حساب</small>
              </div>
              <div
                class="flex-row flex-sm-row my-4 text-center user-types-list"
              >
                <label class="select">
                  <select
                    class="text-center select form-control"
                    [(ngModel)]="selectedType"
                    (change)="onChange($event.target.value)"
                  >
                    <option class="bg-white text-black" disabled [value]="null">
                      الرجاء إختيار نوع العميل
                    </option>

                    <option        class="bg-white text-black" [value]="userTypes.TRANSPORTER" >
                      ناقل
                    </option>
                  
                    <option
                      class="bg-white text-black"
                      [value]="userTypes.SELLER"
                    >
                      بائع
                    </option>
                    <option
                      class="bg-white text-black"
                      [value]="userTypes.BUYER"
                    >
                      مشتري
                    </option>
                    <option
                      class="bg-white text-black"
                      [value]="userTypes.BUYER_SELLER"
                    >
                      مشتري وبائع
                    </option>
                  </select>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-register-buyer-vendor
      [pairingCode]="pairingCode"
      *ngIf="selectedType === userTypes.BUYER_SELLER"
    ></app-register-buyer-vendor>
    <app-register-buyer
      [pairingCode]="pairingCode"
      *ngIf="selectedType === userTypes.BUYER"
    ></app-register-buyer>
    <app-register-seller
      [pairingCode]="pairingCode"
      *ngIf="selectedType === userTypes.SELLER"
    ></app-register-seller>
    <app-register-transporter
      *ngIf="selectedType === userTypes.TRANSPORTER"
    ></app-register-transporter>
  </div>
</div>
